import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useCallback, useContext, useMemo } from "react";

import ShotContext from "components/Shot/ShotContext";
import { UserGuides } from "constants/constants";
import { SLAPSHOT_MOTION_VECTORS_GUIDE_URL } from "constants/urls";
import { UserContext } from "layouts/SlapshotMainLayout";

import styles from "./TrackingOutputGuide.module.scss";

const SmartVectorsOutputGuide = () => {
  const user = useContext(UserContext);
  const { requestSmartVectorsAddRoiRef } = useContext(ShotContext);
  const tips = useMemo(
    () => user?.preferences?.tips || [],
    [user?.preferences?.tips],
  );
  const showTip =
    user?.preferences !== undefined &&
    !tips.includes(UserGuides.SmartVectorsOutputGuide) &&
    !user?.preferences?.hideTips;

  const onClose = useCallback(() => {
    user?.setPreferences("tips", UserGuides.SmartVectorsOutputGuide, true);
  }, [user]);

  const onAddRegionClick = useCallback(() => {
    requestSmartVectorsAddRoiRef.current?.();
  }, [requestSmartVectorsAddRoiRef]);

  if (!showTip) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Not happy with this output?</div>

        <div onClick={onClose}>
          <Close fontSize="small" className={styles.close} />
        </div>
      </div>

      <div className={styles.description}>
        Click{" "}
        <a
          href={SLAPSHOT_MOTION_VECTORS_GUIDE_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.guideLink}
        >
          here
        </a>{" "}
        to view our step by step guide on generating motion vectors.
      </div>

      <div className={styles.buttonRow}>
        <Button className={styles.button} onClick={onAddRegionClick}>
          Add region of int.
        </Button>
      </div>
    </div>
  );
};

export default SmartVectorsOutputGuide;
